import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Lineicons from "@lineiconshq/react-lineicons";
import { EyeStroke } from "@lineiconshq/free-icons";
import HomeCharts from '../components/HomeCharts';

pdfMake.vfs = pdfFonts.vfs;
const Home = () => {

    const chartDataSets = {
        revenue: { month: [120, 190, 300, 250, 220, 180, 210, 260, 230, 280, 300, 320] },
        bookings: { month: [30, 40, 60, 50, 70, 80, 65, 90, 85, 95, 110, 120] },
        renters: { month: [10, 15, 20, 18, 25, 30, 28, 35, 40, 38, 45, 50] },
        vendors: { month: [5, 8, 12, 10, 14, 18, 16, 20, 22, 24, 26, 30] }
    };

    const tableRef = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        const table = $(tableRef.current).DataTable({
            responsive: true,
            pageLength: 5,
            lengthChange: false,
            ordering: true,
            destroy: true,
            dom:
                "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
            buttons: [
                { extend: "copy", text: "Copy" },
                { extend: "excel", text: "Excel" },
                { extend: "pdf", text: "PDF" },
                { extend: "print", text: "Print" },
            ],
        });

        return () => table.destroy();
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="dashTabs">
                        <ul className="nav nav-tabs d-flex align-items-center" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="users-tab" data-bs-toggle="tab" data-bs-target="#users" type="button" role="tab" aria-controls="users" aria-selected="true">
                                    <div className="col">
                                        <div className="card radius-10 bg-gradient-cosmic">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">	Total registered users</p>
                                                        <h4 className="my-1 text-white">129</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-user text-white" style={{ fontSize: 40 }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="subscriptions-tab" data-bs-toggle="tab" data-bs-target="#subscriptions" type="button" role="tab" aria-controls="subscriptions" aria-selected="false">
                                    <div className="col">
                                        <div className="card radius-10 bg-gradient-ibiza">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">		Active Subscriptions</p>
                                                        <h4 className="my-1 text-white">79</h4>
                                                    </div>
                                                    <div>
                                                        <i className="bx bx-package text-white" style={{ fontSize: 40 }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="revenue-tab" data-bs-toggle="tab" data-bs-target="#revenue" type="button" role="tab" aria-controls="revenue" aria-selected="false">
                                    <div className="col">
                                        <div className="card radius-10 bg-gradient-ohhappiness">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Total Revenue</p>
                                                        <h4 className="my-1 text-white">$2,500</h4>
                                                    </div>
                                                    <div>
                                                        <img src="images/icons/dollar.png" alt="SAR" style={{ height: 40 }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="support-tab" data-bs-toggle="tab" data-bs-target="#support" type="button" role="tab" aria-controls="support" aria-selected="false">
                                    <div className="col">
                                        <div className="card radius-10 bg-gradient-kyoto">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center card_box">
                                                    <div className="me-auto">
                                                        <p className="mb-0 text-white">Support Tickets</p>
                                                        <h4 className="my-1 text-white">17</h4>
                                                    </div>
                                                    <div>
                                                        <i
                                                            className="bx bx-key text-white"
                                                            style={{ fontSize: 40, transform: 'rotate(90deg)' }}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-12">
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane show active" id="users" role="tabpanel" aria-labelledby="users-tab">
                                    <div className="card radius-10">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0">Users Overview</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center ms-auto font-13 gap-2 mb-3">
                                                <span className="border px-1 rounded cursor-pointer"><i className="bx bxs-circle me-1" style={{ color: '#00084D !important' }} />Users</span>
                                            </div>
                                            <div className="chart-container-9" style={{ height: 300 }}>
                                                <HomeCharts
                                                    label="Users"
                                                    color="#00084D"
                                                    data={chartDataSets.renters.month}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="subscriptions" role="tabpanel" aria-labelledby="subscriptions-tab">
                                    <div className="card radius-10">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0">Subscriptions Overview</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center ms-auto font-13 gap-2 mb-3">
                                                <span className="border px-2 py-1 rounded cursor-pointer">
                                                    <i className="bx bxs-circle me-1" style={{ color: '#00084D !important' }} />
                                                    Active
                                                </span>
                                            </div>

                                            <div className="chart-container-9" style={{ height: 300 }}>
                                                <HomeCharts
                                                    label="Subscriptions"
                                                    color="#0090eb"
                                                    data={chartDataSets.bookings.month}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="revenue" role="tabpanel" aria-labelledby="revenue-tab">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="card radius-10 mb-3">
                                                <div className="card-header d-flex align-items-center justify-content-between">
                                                    <h6 className="mb-0">Revenue Overview</h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="chart-container-9" style={{ height: 300 }}>
                                                        <HomeCharts
                                                            label="Revenue"
                                                            color="#00084D"
                                                            data={chartDataSets.revenue.month}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-pane" id="support" role="tabpanel" aria-labelledby="support-tab">
                                    <div className="card radius-10">
                                        <div className="card-header d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0">Support Overview</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="chart-container-9" style={{ height: 300 }}>
                                                <HomeCharts
                                                    label="Tickets"
                                                    color="#0090eb"
                                                    data={chartDataSets.vendors.month}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card radius-10 mt-3">
                                <div className="card-body">
                                    <h6 class="mb-0 me-2">Recent Users</h6>
                                    <div className="tab-content py-3">
                                        <div className="tab-pane fade show active" id="bookingsTab">
                                            <div className="entries-wrapper mb-3">
                                                <label className="entries-label">
                                                    <span>Showing</span>
                                                    <select className="entries-select">
                                                        <option value={10} selected>10</option>
                                                        <option value={25}>25</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                    </select>
                                                    <span>Entries</span>
                                                </label>
                                            </div>
                                            <table ref={tableRef} className="table table-striped table-bordered align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Profile Photo</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>User Name</th>
                                                        <th>Email</th>
                                                        <th>Phone Number</th>
                                                        <th>Subscription Plan</th>
                                                        <th>SEE</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><img src="images/avatars/avatar-1.png" class="rounded-circle" width="40" height="40" /></td>
                                                        <td>John</td>
                                                        <td>Doe</td>
                                                        <td>@john_doe</td>
                                                        <td>john.doe@email.com</td>
                                                        <td>(511)-234-5678</td>
                                                        <td><select class="status-select" disabled=""> <option selected="">Premium</option> </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul class="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management"><i class="lni lni-eye" data-bs-toggle="tooltip" title="View"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i class="bx bx-block" data-bs-toggle="tooltip" title="Block"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i class="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td><img src="images/avatars/avatar-2.png" class="rounded-circle" width="40" height="40" /></td>
                                                        <td>Sarah</td>
                                                        <td>Smith</td>
                                                        <td>@sarah_smith</td>
                                                        <td>sarah.smith@email.com</td>
                                                        <td>(415)-678-4321</td>
                                                        <td><select class="status-select" disabled=""> <option selected="">Free</option> </select></td>
                                                        <td>4</td>
                                                        <td>
                                                            <ul class="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management"><i class="lni lni-eye" data-bs-toggle="tooltip" title="View"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i class="bx bx-block" data-bs-toggle="tooltip" title="Block"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i class="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td><img src="images/avatars/avatar-4.png" class="rounded-circle" width="40" height="40" /></td>
                                                        <td>Michael</td>
                                                        <td>Brown</td>
                                                        <td>@mike_b</td>
                                                        <td>michael.b@email.com</td>
                                                        <td>(212)-555-0198</td>
                                                        <td><select class="status-select" disabled=""> <option selected="">Basic</option> </select></td>
                                                        <td>2</td>
                                                        <td>
                                                            <ul class="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management"><i class="lni lni-eye" data-bs-toggle="tooltip" title="View"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i class="bx bx-block" data-bs-toggle="tooltip" title="Block"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i class="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td><img src="images/avatars/avatar-3.png" class="rounded-circle" width="40" height="40" /></td>
                                                        <td>Emily</td>
                                                        <td>Johnson</td>
                                                        <td>@emily_j</td>
                                                        <td>emily.j@email.com</td>
                                                        <td>(305)-987-6543</td>
                                                        <td><select class="status-select" disabled=""> <option selected="">Premium</option> </select></td>
                                                        <td>16</td>
                                                        <td>
                                                            <ul class="tbl_actions_wrap d-flex align-items-center gap-2">
                                                                <li><Link to="/user-management"><i class="lni lni-eye" data-bs-toggle="tooltip" title="View"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#decline_modal"><i class="bx bx-block" data-bs-toggle="tooltip" title="Block"></i></Link></li>
                                                                <li><Link to="#" data-bs-toggle="modal" data-bs-target="#deleteRenterModal"><i class="bx bx-trash" data-bs-toggle="tooltip" title="Delete"></i></Link></li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                
                <div className="modal fade" id="decline_modal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body">
                                <label className="form-label">Reason for blocking:</label>
                                <textarea className="form-control" rows={3} placeholder="Enter reason..." defaultValue={""} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-decline" data-bs-dismiss="modal">Cancel</button>
                                <button className="btn btn-approve text-white px-4" data-bs-dismiss="modal"> Block</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="deleteRenterModal" tabIndex={-1} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmation alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            </div>
                            <div className="modal-body delete-heading">
                                <i className="bi bi-trash fs-1 mb-3" />
                                <h5>Are you sure you want to delete this user?</h5>
                            </div>
                            <div className="modal-footer justify-content-center">
                                <button className="btn btn-decline" data-bs-dismiss="modal">No</button>
                                <button className="btn btn-approve px-4">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Home